import { inject, Injectable } from '@angular/core';
import { ActivitiesAggrigatorModel } from '@shared/model/activities-aggrigator-model';
import { NotificationStrategyFactory } from './factory/notification-strategy-factory';

@Injectable({
  providedIn: 'root'
})
export class TemplateNotificationGeneratorService {
  private factory = inject(NotificationStrategyFactory);

  public generateNotification(activity: ActivitiesAggrigatorModel, receiver: string): string {
    const strategy = this.factory.create(activity?.verb!);
    const message = strategy.createText(activity, receiver, false);

    return message as string;
  }
}
